import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  reservedBedsList,
  releaseReservedBed,
} from "../../../../store/actions/bedsAction";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";
// card
import Card from "react-bootstrap/Card";
import blueBed from "../../../../assets/images/blueBed.png";
import yellowBed from "../../../../assets/images/yellowBed.png";
import redBox from "../../../../assets/images/red.png";
import yellowBox from "../../../../assets/images/yellow.png";
import alert from "../../../../assets/images/alert.png";
import ManageReserveOccupy from "./ManageReserveOccupy";
import moment from "moment";
import styles from "../../../common/modal/Popup.module.css";
// card
const ReservedBeds = () => {
  const { wardId } = useParams();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [selectBed, setSelectBed] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = (val, e) => {
    setSelectBed(val);
    setShow1(true);
  };

  const handleShow = (val, e) => {
    setShow(true);
    setSelectBed(val);
  };

  const {
    isBedRecordUpdated,
    error: apiError,
    isLoader,
    reservedBeds,
  } = useSelector((state) => state.beds);

  useEffect(() => {
    dispatch(reservedBedsList({ wardId })).then(({ payload }) => {
      if (payload?.success) {
        console.log("payload?.data", payload?.data);
      } else {
        setIsShow(true);
      }
    });
  }, []);

  useEffect(() => {
    if (isBedRecordUpdated) {
      dispatch(reservedBedsList({ wardId })).then(({ payload }) => {
        if (payload?.success) {
          console.log("payload?.data", payload?.data);
        } else {
          setIsShow(true);
        }
      });
    }
  }, [isBedRecordUpdated]);

  const getDate = (val) => {
    let dt = new Date(val);
    return <span>{moment(dt).format("DD/MM/YYYY")}</span>;
  };

  const submitHandler = (e) => {
    console.log("isaction called");
    e.preventDefault();
    dispatch(
      releaseReservedBed({ wardId: wardId, bedId: selectBed?._id })
    ).then(({ payload }) => {
      console.log("payload", payload);
      if (payload.success) {
        handleClose1();
      } else {
        setIsShow(true);
      }
      setIsActionCalled(false);
    });
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  return (
    <>
      <ManageReserveOccupy
        show={show}
        onHide={handleClose}
        title={"Occupy Reserved Bed"}
        selectBed={selectBed}
      />
      {/* Modal Release */}
      <Modal
        show={show1}
        onHide={handleClose1}
        aria-labelledby="contained-modal-title-vcenter"
        className={styles.modal}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body align="center">
          <img src={alert} />
          <h4>Release Bed</h4>
          <div>
            <p>Are you sure you want to release bed?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <span className="cancel-btn" onClick={handleClose1}>
            No
          </span>
          <Button
            variant="primary"
            className="model-btn"
            onClick={(e) => submitHandler(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      <div className="reserved-card  shadow p-4 mb-5 bg-white rounded">
        <Row xs={1} md={4} className="g-4">
          {reservedBeds &&
            reservedBeds.map((bed) => (
              <Col key={bed?._id}>
                <Card>
                  <Card.Body className="bed-card">
                    <div className="d-flex card-top">
                      <Card.Img
                        variant="left"
                        className="p-2"
                        style={{ width: "72px", height: "72px" }}
                        src={yellowBed}
                      />
                      <Card.Title
                        style={{
                          fontSize: "15px",
                          marginTop: "14px",
                          fontWeight: "800",
                          marginLeft: "4px",
                        }}
                      >
                        Reserved 
                       
                        <p className="mt-2 text-nowrap">
                          <span>NHS No.:</span> {bed?.nhsNumber}
                        </p>
                        <p className="text-nowrap" style={{marginTop:'-10px'}}>
                          <span>Patient Initials:</span> {bed?.patientInitials ? bed?.patientInitials : "\u00A0"}
                        </p>
                        <p style={{ fontWeight: "600" }}>
                          <span>RD: </span> {getDate(bed?.dateOfReservation)}
                        </p>
                       
                      </Card.Title>
                    </div>

                    <div className="group-body ">
                      <span
                        className="btn2 me-2"
                        onClick={(e) => handleShow1(bed, e)}
                      >
                        Free
                      </span>
                      <span
                        className="btn1"
                        onClick={(e) => handleShow(bed, e)}
                      >
                        Occupy
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordUpdated: isShow,
          successMsg: "",
          title: "Warning",
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default ReservedBeds;
